export enum RouteParamnames {
    addressAreaId = 'addressAreaId',
    chatId = 'chatId',
    contactId = 'contactId',
    customerId = 'customerId',
    newsId = 'newsId',
    phase = 'phase',
    phaseActivity = 'phaseActivity',
    projectId = 'projectId',
    reply = 'reply',
    timelineId = 'timelineId',
    token = 'token',
    workareaId = 'workareaId',
}
